import React, { Component } from 'react';
import { connect } from 'react-redux';
import HelpModal from 'sub_components/Common/HelpModal';

const CDN_URL = process.env.REACT_APP_CDN_URL;
const InfoIconDefault = `${CDN_URL}common/help/info-icon-default.svg`;
const InfoIconHoverBilling = `${CDN_URL}common/help/info-icon-hover-billing.svg`;
const InfoIconHoverProfile = `${CDN_URL}common/help/info-icon-hover-profile.svg`;
const InfoIconHoverStorage = `${CDN_URL}common/help/info-icon-hover-storage.svg`;
const InfoIconHoverSupport = `${CDN_URL}common/help/info-icon-hover-support.svg`;

class Information extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modal: false,
			showModal: false,
			selected: false,
		};
	}
	componentDidMount() {
		const { site } = this.props;
		this.setState({ module: site.module });
	}

	componentDidUpdate(prevProps) {
		const { site } = this.props;
		if (prevProps.site.module !== site.module) {
			this.setState({ module: site.module });
		}
	}

	getModuleImage = () => {
		return InfoIconDefault;
	};

	getModuleHoverImage = module => {
		switch (module) {
			case 'BILLING':
				return InfoIconHoverBilling;
			case 'ACCOUNT':
				return InfoIconHoverProfile;
			case 'SUPPORT':
				return InfoIconHoverSupport;
			case 'STORAGE':
				return InfoIconHoverStorage;
			default:
				return InfoIconHoverSupport;
		}
	};
	showModal = () => {
		const { showModal, selected } = this.state;
		this.setState({ showModal: !showModal, selected: !selected });
	};
	onMouseOver = () => {
		const { module } = this.state;
		const image = document.getElementById('information-module-image');
		if (image) {
			image.src = this.getModuleHoverImage(module);
		}
	};
	onMouseOut = () => {
		const { module } = this.state;
		const image = document.getElementById('information-module-image');
		if (image) {
			image.src = this.getModuleImage(module);
		}
	};

	render() {
		const { showModal, module } = this.state;
		const { breakpoint, site, navigate } = this.props;

		return (
			<>
				{showModal && (
					<HelpModal
						toggleOpen={this.showModal}
						breakpoint={breakpoint}
						isOpen={showModal}
						area='portal'
						navigate={navigate}
					/>
				)}
				<div
					className={`information-image-container ${site?.module}`}
					id={
						site?.module === 'LOGIN' || site?.module === 'HOME'
							? 'information-image-home'
							: 'information-image'
					}
					onClick={this.showModal}
					onMouseOver={this.onMouseOver}
					onMouseOut={this.onMouseOut}
					data-cy='information-button'
				>
					<img src={this.getModuleImage(module)} id='information-module-image' />
					<div className='title header10'>SUPPORT</div>
				</div>
			</>
		);
	}
}

function mapStateToProps(state) {
	return {
		site: state.site_tracking,
	};
}

export default connect(mapStateToProps, null)(Information);
